
            const data = {"name":"plus","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" _fill=\"#171614\" d=\"M34.96 25.04V1h-9.92v24.04H1v9.92h24.04V59h9.92V34.95H59v-9.91H34.96z\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                